import { render, staticRenderFns } from "./SnowEffect.vue?vue&type=template&id=1a72cbd9&scoped=true&"
import script from "./SnowEffect.vue?vue&type=script&lang=js&"
export * from "./SnowEffect.vue?vue&type=script&lang=js&"
import style0 from "./SnowEffect.vue?vue&type=style&index=0&id=1a72cbd9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a72cbd9",
  null
  
)

export default component.exports